<template>
  <div v-if="events && events.length" class="events-slider page-container">
    <header class="events-slider__header">
      <div class="events-slider__title-wrap">
        <h3 class="events-slider__title">{{ title }}</h3>
        <a v-if="link" :href="link" class="events-slider__more">
          {{ $t('see_all') }}
        </a>
      </div>
      <div class="events-slider__navigation">
        <div class="swiper-button-prev swiper-button-prev--events" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-next--events" slot="button-next"></div>
      </div>
    </header>
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide class="swiper-item" v-for="(item, i) in events" :key="i">
        <EventsSliderItem
          :address="item.data.address"
          :short-description="item.data.short_description"
          :start-date="item.data.start_date"
          :end-date="item.data.end_date"
          :start-time="item.data.start_time"
          :end-time="item.data.end_time"
          :link="item.data.link"
          :image="item.data.image"
          :image-alt="item.data.image_alt"
          :title="item.data.title"
          :block-name="title"
          :position="i + 1"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { isTouch } from '../../mixins/isTouchDevice'

import EventsSliderItem from './EventsSliderItem'

export default {
  name: 'EventsSlider',
  mixins: [isTouch],
  props: {
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    events: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    EventsSliderItem
  },
  data () {
    return {
      swiperOption: {
        watchSlidesVisibility: true,
        spaceBetween: 15,
        slidesPerView: 1.2,
        navigation: {
          nextEl: '.swiper-button-next--events',
          prevEl: '.swiper-button-prev--events'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          319: {
            slidesPerView: 1.2
          },
          550: {
            slidesPerView: 2.2
          },
          769: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="sass">
@import "../../../node_modules/swiper/css/swiper.min.css"
@import "../../styles/swiper/swiper"

.page-container
  padding: 0

  +mmin($tablet--hor)
    padding: 0 15px

.events-slider ::v-deep
  .swiper-wrapper
    align-items: stretch

  .swiper-item
    height: auto

.events-slider__header,
.swiper-container
  padding: 0 15px

  +mmin($tablet--hor)
    padding: 0

.events-slider__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 15px

  +mmin($tablet)
    margin-bottom: 30px

.events-slider__title-wrap
  display: flex
  flex-flow: row wrap
  align-items: baseline
  justify-content: space-between
  width: 100%

  +mmin($tablet)
    width: auto
    justify-content: flex-start

.events-slider__title
  font-size: 18px
  font-weight: 500
  padding: 0
  margin: 0

  +mmin($tablet--hor)
    font-size: 24px

.events-slider__more
  color: $main-color
  font-size: 14px
  font-weight: 400 //Rubik 300

  +mmin($tablet)
    font-size: 16px
    margin-left: 20px

  &:hover,
  &:focus,
  &:active
    color: $main-color--hover

.events-slider__navigation
  display: none
  position: relative
  width: 70px

  +mmin($tablet)
    display: block

</style>
